import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClaimsService } from 'src/app/services/claims.service';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';

@Component({
  selector: 'app-assess-contribution-to-costs',
  templateUrl: './assess-contribution-to-costs.component.html',
  styleUrls: ['./assess-contribution-to-costs.component.scss']
})
export class AssessContributionToCostsComponent implements OnInit {
  claimId: any;
  taskId:any;
  constructor(
    private route: ActivatedRoute,
    private loaderService: GlobalLoadingService,
    private claimsService: ClaimsService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.claimId = decodeURIComponent(params['claimId']);
      this.taskId = decodeURIComponent(params['taskId']);
      // console.log(this.claimId);
      // console.log(this.taskId)
      this.postWorkflowActivity(this.claimId, this.taskId);
    });
  }

  public postWorkflowActivity(claimId: any, taskId: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimId? claimId : null;
    requestParam.taskId = taskId? taskId : null;
    requestParam.actionName = 'complete_task';
    requestParam.payload = {
      "completed":true
    }
    this.loaderService.startLoadingIndicator('getWorkflowActivity');
    thisObj.claimsService.postWorkflowActivity(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowActivity');
        this.getWorkflowFulfill(claimId);
      }
    }); 
  }

  public getWorkflowFulfill(claimId: any) {
    const thisObj = this;
    const requestParam: any = {};
    requestParam.claimId = claimId? claimId : null;
    this.loaderService.startLoadingIndicator('getWorkflowFulfill');
    thisObj.claimsService.getWorkflowFulfill(requestParam).subscribe(result => {
      if (result.status === 'Success') {
        this.loaderService.stopLoadingIndicator('getWorkflowFulfill');
        this.router.navigate(['/claimDetail/',(this.claimId)]);
      }
    }); 
  }

}
